(function () {
    'use strict';

    function resourcePartnerConnectionsDataService($http) {

        var baseUrl = '[BuildifyApiHost]/api/partnerconnections/';

        function update(entityId, resourcePartnerId, data) {
            return $http.post((baseUrl + entityId + '/partners/' + resourcePartnerId).toLowerCase(), data).then(function (response) {
                return response.data;
            });
        };

        return {
            update: update
        }
    }

    resourcePartnerConnectionsDataService.$inject = ['$http'];

    angular.module('ecap.crm').service('resourcePartnerConnectionsDataService', resourcePartnerConnectionsDataService);
})();
